import { FC } from 'react';
import { RouteConfig } from '@/shared/lib';
import { Icon, IconType } from '@/shared/ui';

type Props = {
  route: RouteConfig;
  className?: string;
};

/** Иконка пункта меню: строковый тип рендерится через Icon, готовый ReactNode — как есть. */
export const RouteNavIcon: FC<Props> = ({ route, className }) => {
  if (typeof route.navbar?.icon === 'string') {
    return <Icon type={route.navbar.icon as IconType} width={16} className={className ?? 'text-muted-foreground'} />;
  }
  return <>{route.navbar?.icon}</>;
};
